@if (inputForm && fieldKey && fieldConfig) {
  <ng-container *transloco="let t">
    <form [formGroup]="inputForm">
      @switch (fieldConfig.fieldConfigTypeId) {
        @case (FieldConfigType.BOOLEAN) {
            <app-checkbox [formControlName]="fieldKey" [label]="label"/>
        }
        @case (FieldConfigType.SELECT) {
            <app-select [formControlName]="fieldKey" [items]="fieldConfig.options" valueKey="id" [isDropdownListFullWidth]="true"
                        [translatedLabels]="translatedLabels" [label]="label"/>
        }
        @case (FieldConfigType.MULTISELECT) {
          <app-multiselect-dropdown [options]="options" [isDropdownListFullWidth]="true"
                                    [formControlName]="fieldKey"
                                    [dropdownLabel]="label"/>
        }
        @case (FieldConfigType.TEXT) {
            <app-input [type]="'text'" [formControlName]="fieldKey" [label]="label"/>
        }
        @case (FieldConfigType.NUMBER) {
            <app-input [type]="'number'" [formControlName]="fieldKey" [label]="label"/>
        }
        @case (FieldConfigType.DATE) {
          <app-date-time-input [formControlName]="fieldKey" [displayTime]="false"
                               [label]="label | titlecase"/>
        }
        @case (FieldConfigType.TIME) {
          <app-duration-input [formControlName]="fieldKey"
                              [label]="label | titlecase"/>
        }
      }
    </form>
  </ng-container>
}
